// extracted by mini-css-extract-plugin
export default {"root":"l9Hr7JmdvgxINS5Vqmbu"};